var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.5631 11.5871C34.7822 18.4277 32.2857 26.1059 26.4606 30.2941C20.6355 34.6218 12.7299 34.6218 6.9048 30.2941C1.07967 25.9663 -1.41681 18.4277 0.802286 11.5871C3.02138 4.74654 9.40129 0 16.6133 0C23.9641 0 30.344 4.74654 32.5631 11.5871ZM16.752 1.53564C10.2334 1.53564 4.40831 5.72376 2.32791 12.0059C0.247509 18.2881 2.46661 25.1287 7.87565 29.0376C13.146 32.9465 20.3581 32.9465 25.6284 29.0376C30.8988 25.1287 33.1179 18.2881 31.1762 12.0059C29.0958 5.72376 23.2706 1.53564 16.752 1.53564Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.0428 11.3671C24.8138 11.5647 25.4217 12.1435 25.6292 12.8776C26.0147 14.2188 25.9999 17.0141 25.9999 17.0141C25.9999 17.0141 25.9999 19.7953 25.6292 21.1365C25.4217 21.8706 24.8138 22.4494 24.0428 22.6471C22.6342 23 17 23 17 23C17 23 11.3805 23 9.95716 22.6329C9.18616 22.4353 8.57825 21.8565 8.37067 21.1224C8 19.7953 8 17 8 17C8 17 8 14.2188 8.37067 12.8776C8.57825 12.1435 9.20098 11.5506 9.95716 11.3529C11.3657 11 17 11 17 11C17 11 22.6342 11 24.0428 11.3671ZM15.2059 14.4306L19.8912 17L15.2059 19.5694V14.4306Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.fa5aecda55c15dd1f29e8680c14b69ae.svg";
export { ForwardRef as ReactComponent };